function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      // eslint-disable-next-line no-mixed-operators
      var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
}

// fix weird bug when transitioning from the tradebook to the market listing - FIXED
// live update the best current trades and ask - DONE
// show the user their trades
// execute trades

export const executeTrade = (information) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        const documentID = uuidv4();

        const firestore = getFirestore();
        const tradeRef = firestore.collection('trades').doc(information.company);
        const tradeBookRef = firestore.collection('trading-book').doc(information.fromUID);
        const companyRef = firestore.collection('companies').doc(information.company);
        const userRef = firestore.collection('users');

        let tradeValue = information.amount * information.price;
        let stockOwned = 0;

        if(information.type === 'buy') {
            tradeValue = tradeValue * -1;
        }

        // this will need to be optimized on the DB end
        tradeBookRef.get().then((doc) => {
            const data = doc.data();

            // determine the amount of stock the person owns
            for(const key in data) {
                const entry = data[key];

                if(entry.company === information.company) {
                    stockOwned += parseInt(entry.amount)
                }
            }
            
            // if user puts out a bid (i.e. type === sell), they are willing to buy this amount of stock at x price
            // need to verify they have enough cash
                        
            if(information.type === 'buy' && information.amount > stockOwned) {
                // user does not own enough stock
                dispatch({ type: 'INSUF_STOCK' });
            } else {
                userRef.where('firstName', '==', information.counterparty).get().then((snapshot) => {
                    // we should never have more than one username associated with an account
                    snapshot.forEach((doc) => { information.counterpartyUID = doc.id; });
        
                    const date = new Date();
        
                    information.date = date.getTime();
        
                    information.originalAmount = information.amount;
        
                    tradeRef.set({
                        [documentID]: information
                    }, {merge: true}).then(() => {
        
                        if(information.isBest) {
                            // update the best asking in the company reference
                            let fieldBest = 'bestAsk';
                            let fieldAmount = 'bestAskAmount';
        
                            if(information.type === 'sell') {
                                fieldBest = 'bestBid'
                                fieldAmount = 'bestBidAmount'
                            }
        
                            companyRef.set({
                                [fieldBest]: information.price,
                                [fieldAmount]: information.amount
                            }, {merge: true}).then(() => {
                                dispatch({ type: 'TRADE_EXECUTED', information });
                            });
                        }
        
                        dispatch({ type: 'TRADE_EXECUTED', information });
        
                    }).catch((err) => {
                        dispatch({ type: 'TRADE_EXECUTE_FAILED', err });
                    });
        
                }).catch(err => {
                    // implement UI for this response
                    dispatch({ type: 'TRADE_COUNTERPARTY_NOT_FOUND', err });
                });
            }
        })
    }
}

// information is a list of orders which have to be fulfilled

export const fillOrder = (information, uid) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        const firestore = getFirestore();
        let batch = firestore.batch();
        const userRef = firestore.collection('users');

        let tradeValue = 0;

        // TODO: crashes when no data
        const tradeType = information[0].type;

        for(const key in information) {
            const order = information[key];

            const tradeRef = firestore.collection('trades').doc(order.company);
            const tradebookRef = firestore.collection('trading-book').doc(uid);

            var today = new Date();
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = today.getFullYear();

            today = mm + '/' + dd + '/' + yyyy;

            batch.set(tradeRef, {
                [order.tradeID]: {
                    amount: firestore.FieldValue.increment(-1 * order.amount),
                }
            }, {merge: true});

            // create the notification for the counterparty

            const notification = {
                message: 'New trade has been requested.',
                amount: order.amount,
                company: order.company,
                price: order.price,
                type: order.type,
                from: uid,
                to: order.tradeUID,
                viewed: false,
            };

            // add the respective trade to the users trade book

            const cost = parseFloat(notification.price) * parseInt(notification.amount);

            if(order.counterparty === '') {
                const tradebookEntryID = uuidv4();
                const counterpartyTradebookEntryID = uuidv4();

                const counterpartyRef = firestore.collection('users').doc(order.tradeUID);
                const counterpartyTradebookRef = firestore.collection('trading-book').doc(order.tradeUID);

                const userRecord = {
                    date: today,
                    amount: order.amount,
                    company: order.company,
                    counterparty: order.counterparty,
                    price: order.price,
                    type: order.type,
                    uid,
                }

                const counterpartyRecord = {
                    ...userRecord,
                    type: (userRecord.type === 'buy') ? 'sell' : 'buy',
                    counterparty: '',
                    uid: order.tradeUID,
                }

                batch.set(tradebookRef, {
                    [tradebookEntryID]: userRecord
                }, {merge: true});

                batch.set(counterpartyTradebookRef, {
                    [counterpartyTradebookEntryID]: counterpartyRecord
                }, {merge: true});

                // update the counterparties assets
                batch.set(counterpartyRef, {
                    assets: firestore.FieldValue.increment((counterpartyRecord.type === 'sell') ? cost : cost * -1),
                }, {merge: true});
            }
            
            if(uid !== notification.to) {
                const notificationRef = firestore.collection('notifications').doc(notification.to);
            
                batch.set(notificationRef, { 
                    'notifications': firestore.FieldValue.arrayUnion(notification) 
                }, {merge: true});
            }

            tradeValue += cost
        }

        let previousAssets = 0;
        userRef.doc(uid).get().then((doc) => {
            previousAssets = doc.data().assets;
            
            userRef.doc(uid).set({
                assets: firestore.FieldValue.increment((tradeType === 'sell') ? tradeValue : tradeValue * -1),
                prevAssets: previousAssets,
            }, {merge: true}).then(() => {
                // enter the orders and send the notifications
                batch.commit().then(() => {
                    // trades have been entered into the database
                    dispatch({ type: 'ORDER_FILLED', information });
                });
            });
        });
    }
}

export const deleteNotification = (information) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        const firestore = getFirestore();
        const ref = firestore.collection('notifications').doc(information.to);

        ref.update({
            'notifications': firestore.FieldValue.arrayRemove(information)
        }).then(() => {
            // insert another notification with type
            console.log('successfully deleted')
            dispatch({ type: 'DELETE_NOTIFICATION', information });
        }).catch((err) => {
            dispatch({ type: 'FAILED_DELETE_NOTIFICATION', err });
        });
    }
}